import { Box, styled } from "~/common/mui";
import { C_PRIMARY_DISABLED } from "~/common/components/icon/Colors";

export const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateAreas: '"title title" "form infoText" "form pdfLink" "form table"',
  columnGap: theme.spacing(4),
  [theme.breakpoints.down("desktop-s")]: {
    gridTemplateAreas: '"title" "infoText" "form" "pdfLink" "table"',
  },
}));

export const PageTitleWrapper = styled(Box)({ gridArea: "title" });

export const Form = styled(Box)(({ theme }) => ({
  gridArea: "form",
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.down("tablet")]: { gap: theme.spacing(2) },
}));

export const InfoText = styled(Box)(({ theme }) => ({
  ...theme.typography.labelLarge,
  gridArea: "infoText",
  color: theme.palette.text.primary,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  "& > p": { margin: 0 },
  [theme.breakpoints.down("desktop-s")]: { marginBottom: theme.spacing(3) },
}));

export const DownloadLinkWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gridArea: "pdfLink",
  alignSelf: "flex-end",
  justifySelf: "flex-end",
  [theme.breakpoints.down("desktop-s")]: {
    margin: `${theme.spacing(4)} 0 ${theme.spacing(2)} 0`,
  },
  [theme.breakpoints.down("tablet")]: { alignSelf: "flex-start" },
}));

export const TableResult = styled(Box)(({ theme }) => ({
  gridArea: "table",
  paddingTop: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  "& table": { width: "100%" },
  "& th": { fontWeight: "bold" },
  "& td": { verticalAlign: "middle" },
  [theme.breakpoints.down("desktop-s")]: { padding: 0 },
}));

export const FormTitle = styled("div")(({ theme }) => ({
  ...theme.typography.titleLarge,
  color: theme.palette.text.primary,
}));

export const Section = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const FormRow = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(4),
  [theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

export const FormButtonSection = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  [theme.breakpoints.down("tablet")]: {
    flexDirection: "column-reverse",
    "& button:last-child": { marginBottom: theme.spacing(2) },
  },
}));

export const FormItem = styled("div")({ display: "flex" });

export const FormItemImage = styled("img")(({ theme }) => ({
  marginRight: theme.spacing(2),
  width: 66,
  height: 70,
  [theme.breakpoints.down("tablet")]: { display: "none" },
}));

export const FormItemImageMobile = styled("img")(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("tablet")]: {
    display: "block",
    width: 112,
    height: 112,
    margin: 0,
  },
}));

export const RadioSwitchOptions = styled("div")(({ theme }) => ({
  display: "flex",
  "& > * + *": {
    marginLeft: theme.spacing(4),
  },
}));

export const RadioSwitchOption = styled("div")(({ theme }) => ({
  display: "flex",
  "& .Mui-disabled": {
    color: `${theme.palette.divider} !important`,
  },
  "& .Mui-checked.Mui-disabled": {
    color: `${C_PRIMARY_DISABLED} !important`,
  },
}));
